<template>
  <v-dialog :value="value" @input="$emit('input')" width="340">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Add to Teammate's Panel
      </v-card-title>
      <v-divider></v-divider>
      <v-list>
        <v-list-item
          v-for="user in teammates"
          :key="user.id"
          @click="
            addNoteToTeammate({ teammateId: user.id, pageId: page.id });
            $emit('select', user.id);
          "
        >
          <v-list-item-avatar>
            <v-img :src="user.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ user.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
import { computed } from '@vue/composition-api';
import { contextsModule } from '@/store/database/contextsModule';
import { currentUserId } from '@/store/useAuth';
import { addNoteToTeammate } from '@/components/ContextDoc/use/useDocActions';

export default {
  props: ['page', 'value'],
  setup(props) {
    const teammates = computed(() => {
      const context = contextsModule.doc(props.page.context).data;
      return Object.values(context.authors).filter(a => a.id != currentUserId.value);
    });
    return { teammates, addNoteToTeammate };
  }
};
</script>

<style></style>
